import React, { useState } from 'react';
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { Microscope, ChevronDown, ChevronUp, MessageSquare, Download, FileText, Sparkles } from 'lucide-react';
import { CommentAnalysis } from './CommentAnalysis';
interface ResearchToolsProps {
  taskId: string;
  videoId?: string;
}
export function ResearchTools({
  taskId,
  videoId
}: ResearchToolsProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  return <div className="mt-12 pt-8 border-t border-border/30" data-id="element-1093">
      <Card className="bg-secondary/20 overflow-hidden" data-id="element-1094">
        <button onClick={() => setIsExpanded(!isExpanded)} className="w-full px-4 py-3 flex items-center justify-between hover:bg-secondary/30 transition-colors text-left" data-id="element-1095">
          <div className="flex items-center gap-2" data-id="element-1096">
            <Microscope size={16} className="text-primary" data-id="element-1097" />
            <span className="text-sm font-medium text-muted-foreground" data-id="element-1098">
              Research Tools & Advanced Analysis
            </span>
            <span className="text-xs bg-primary/20 text-primary px-2 py-0.5 rounded-full" data-id="element-1099">
              Advanced
            </span>
          </div>
          {isExpanded ? <ChevronUp size={16} className="text-muted-foreground" data-id="element-1100" /> : <ChevronDown size={16} className="text-muted-foreground" data-id="element-1101" />}
        </button>

        {isExpanded && <div className="p-4 border-t border-border/30" data-id="element-1102">
            <p className="text-sm text-muted-foreground mb-4" data-id="element-1103">
              Extract additional data for content research and audience analysis
            </p>

            <div className="space-y-3" data-id="element-1104">
              {/* Comment Analysis Tool */}
              <CommentAnalysis taskId={taskId} videoId={videoId} data-id="element-1105" />

              {/* Future research tools can be added here */}
              <div className="pt-3 border-t border-border/20" data-id="element-1106">
                <p className="text-xs text-muted-foreground flex items-center gap-1" data-id="element-1107">
                  <Sparkles size={12} data-id="element-1108" />
                  More research tools coming soon
                </p>
              </div>
            </div>
          </div>}
      </Card>
    </div>;
}